import type { TextareaHTMLAttributes } from "react";

export interface TextareaProps
  extends TextareaHTMLAttributes<HTMLTextAreaElement> {}

/*
複数行の自由記述欄。Input は1行で、Field はラベル付きの組み立て済みで
しかも色が light 固定 (docs/color-token-drift.md のズレそのもの)。
ここはデザイントークンだけを持った素の欄。

**枠は持たない。** 単体で置く場所 (border border-main rounded-lg 等) と、
composer のように外の箱が枠を持つ場所の両方に使えるよう、枠線は
呼び出し側に任せる。base に枠を焼くと、消したい側が className の
上書き勝負になり CSS の並び順に負けて色が戻る
*/
export function Textarea({ className = "", ...props }: TextareaProps) {
  return (
    <textarea
      className={`w-full resize-none bg-transparent font-noto text-main placeholder:text-sub focus:outline-none disabled:opacity-60 ${className}`}
      {...props}
    />
  );
}
